/* RM — autoplay/mute/loop em vídeos de produto + autoload do deferred-media */
(() => {
  /* Configura um <video> para nosso padrão */
  function tuneVideo(v) {
    try {
      // A ordem importa para iOS: primeiro muted/playsinline, depois autoplay
      v.muted = true;
      v.setAttribute('muted', '');
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.loop = true;
      v.setAttribute('loop', '');
      v.autoplay = true;
      v.setAttribute('autoplay', '');

      // Remove controles e desativa alguns menus
      v.removeAttribute('controls');
      v.setAttribute('controlslist', 'nodownload noplaybackrate nofullscreen noremoteplayback');

      // Assim que tiver dados, tenta tocar
      v.addEventListener('loadeddata', () => {
        const p = v.play?.();
        if (p && p.catch) p.catch(() => {}); // ignora bloqueios do navegador
      }, { once: true });
    } catch (e) { /* noop */ }
  }

  /* Varre um nó e ajusta todos os vídeos encontrados */
  function scan(root = document) {
    root.querySelectorAll(
      '.product [data-media-type="video"] video, .product .media video, deferred-media video, .media video'
    ).forEach(tuneVideo);
  }

  document.addEventListener('DOMContentLoaded', () => {
    // Carrega automaticamente o conteúdo dos <deferred-media> quando entrar em viewport
    if (window.customElements?.whenDefined) {
      customElements.whenDefined('deferred-media').then(() => {
        document.querySelectorAll('deferred-media').forEach((dm) => {
          // Usa IntersectionObserver para eficiência
          const io = new IntersectionObserver((entries, obs) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              if (typeof dm.loadContent === 'function' && !dm.hasAttribute('data-rm-loaded')) {
                dm.loadContent();                    // injeta o <video> do <template>
                dm.setAttribute('data-rm-loaded', '1');
                setTimeout(() => scan(dm), 50);      // dá um “tick” e configura o vídeo
              }
              obs.unobserve(entry.target);
            });
          }, { rootMargin: '200px' });
          io.observe(dm);
        });
      });
    }

    // Primeira varredura (caso já haja <video> no DOM)
    scan();
  });

  // Se o tema trocar a mídia/variante e inserir novos nós, ajusta de novo
  const mo = new MutationObserver((mut) => {
    for (const m of mut) {
      m.addedNodes?.forEach((n) => {
        if (n.nodeType !== 1) return;
        if (n.tagName === 'VIDEO') tuneVideo(n);
        else scan(n);
      });
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
